/**
 * Registers lightweight service worker update checks.
 *
 * Triggers `registration.update()` periodically and on focus/visibility,
 * and reloads once when a new service worker takes control.
 */
export function setupServiceWorkerUpdate(): void {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return

    let controllerRefreshTriggered = false

    navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (controllerRefreshTriggered) return
        controllerRefreshTriggered = true
        window.location.reload()
    })

    const triggerUpdate = async (): Promise<void> => {
        try {
            const registration =
                (await navigator.serviceWorker.getRegistration('/'))
                || (await navigator.serviceWorker.getRegistration())
            await registration?.update()
        } catch {
            // Ignore update-check errors (offline, transient network issues, etc.)
        }
    }

    window.addEventListener('focus', () => {
        void triggerUpdate()
    })

    document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
            void triggerUpdate()
        }
    })

    // Safety net: periodic check while the app stays open for long sessions.
    window.setInterval(() => {
        void triggerUpdate()
    }, 60_000)

    void triggerUpdate()
}
